import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { OpportunityTask, UpdateOpportunityTaskRequest } from 'backend/types'
import { updateOpportunityTask } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseUpdateOpportunityTaskOptions {
  onSuccess?: (data: OpportunityTask) => void
  onError?: (error: Error) => void
}

interface UpdateTaskParams {
  opportunityId: number
  taskId: number
  data: UpdateOpportunityTaskRequest
}

export function useUpdateOpportunityTask(options: UseUpdateOpportunityTaskOptions = {}) {
  const { onSuccess, onError } = options
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ opportunityId, taskId, data }: UpdateTaskParams) => {
      return updateOpportunityTask(opportunityId, taskId, data)
    },
    onSuccess: (data, variables) => {
      const { opportunityId } = variables
      // オポチュニティ詳細用
      queryClient.invalidateQueries({ queryKey: queryKeys.opportunity.tasks(opportunityId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.opportunity.all(opportunityId) })
      // 担当タスク一覧用
      queryClient.invalidateQueries({ queryKey: queryKeys.myTasks })
      onSuccess?.(data)
    },
    onError: (error: Error) => {
      onError?.(error)
    },
  })
}
